import LoadingSpinner from '@/app/components/atoms/LoadingSpinner';

/**
 * @component LoadingStep
 * @description Third step of the login flow. Displays a heading and a centered
 * loading spinner while authentication is in progress.
 * @returns The loading state with a spinner and screen-reader announcement.
 */
export default function LoadingStep() {
  return (
    <div className="flex flex-col items-center gap-10">
      <h1
        aria-live="polite"
        className="text-heading text-near-black text-center"
      >
        Logging you in
      </h1>

      <LoadingSpinner size="lg" color="accent" />
    </div>
  );
}
